// @ vendors
const Immutable = require('immutable');

// @ constants
const {
    INSURANCE_REQUEST_RELATED_RNC_STATE_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_STATE_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_STATE_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_STATE_APPRAISAL,
    INSURANCE_REQUEST_RELATED_RNC_POST_CLOSED_PRICE,
} = require('../../insuranceConstants/actionTypes');
const { WIZARD_REQUEST_RESPONSE_OPTIONS, INSURANCE_STATE } = require('../../insuranceConstants/insuranceRequestHome');

const initialState = Immutable.fromJS({
    data: null,
    recommendation: [],
    idExpediente: null,
    isFetching: false,
    hasFetched: false,
    isFetchingRecommendation: false,
    error: '',
    errorRecommendation: '',
    appraisal: {},
    isPostAppraisalClosedPrice: '',
});

const insuranceRequestRelatedRNCState = (state = initialState, action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_RELATED_RNC_STATE_REQUEST:
            return state.merge({
                isFetching: true,
                error: ''
            });

        case INSURANCE_REQUEST_RELATED_RNC_STATE_SUCCESS:
            const { insuranceState, idExpediente } = action.data;

            if (insuranceState && insuranceState.insuranceState === INSURANCE_STATE.INVALID) {
                insuranceState.insurancePlan = '';
            }
            return state.merge({
                data: insuranceState,
                idExpediente: idExpediente,
                hasFetched: true,
                isFetching: false
            });

        case INSURANCE_REQUEST_RELATED_RNC_STATE_FAILURE:
            return state.merge({
                error: action.data.error,
                isFetching: false,
                hasFetched: true
            });

        case INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_REQUEST:
            return state.merge({
                isFetchingRecommendation: true,
                errorRecommendation: ''
            });

        case INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_SUCCESS:
            return state.merge({
                recommendation: action.data,
                isFetchingRecommendation: false
            });

        case INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_FAILURE:
            return state.merge({
                errorRecommendation: action.data.error,
                isFetchingRecommendation: false
            });

        case INSURANCE_REQUEST_RELATED_RNC_STATE_APPRAISAL:
            return state.mergeDeep({
                appraisal: {
                    ...action.data
                }
            })

        case INSURANCE_REQUEST_RELATED_RNC_POST_CLOSED_PRICE:
            return state.merge({
                isPostAppraisalClosedPrice: WIZARD_REQUEST_RESPONSE_OPTIONS[action.data.response],
            });

        default:
            return state
    }
};

module.exports = insuranceRequestRelatedRNCState;
